export const HOTEL = "Hotel";
export const FLIGHT = "Flight";

export const HOTEL_DETAILS = "Hotel details";
export const FLIGHT_DETAILS = "Flight details";
